module.exports = __webpack_public_path__ + "img/news-placeholder.aac1fcff.jpg";